import { PAGE_STATE_CHECK_IN } from 'common/constants/virtualEvent';
import buildIDWithStateScope from 'common/compounds/VirtualEventBuilder/utils/buildIDWithStateScope';

function generateId(id) {
    return buildIDWithStateScope(id, PAGE_STATE_CHECK_IN);
}

export const NODE_ID_PAGE_CONTAINER = generateId('body');
export const NODE_ID_CONTENT_CONTAINER = generateId('modal');
export const NODE_ID_LOGO = generateId('modalLogo');
export const NODE_ID_EVENT_TITLE = generateId('modalHeadline');
export const NODE_ID_COUNTDOWN_TEXT = generateId('modalCountdownV2');
export const NODE_ID_CHECK_IN_BUTTON = generateId('modalCta');
export const NODE_ID_FOOTER_CONTAINER = generateId('footer');
export const NODE_ID_CONTACT_ORGANIZER_BUTTON = generateId('contact');
export const NODE_ID_VISIT_EVENT_PAGE_BUTTON = generateId('eventPage');
export const NODE_ID_CUSTOM_BUTTON = generateId('footerCta');
export const NODE_ID_CUSTOM_BUTTON_TWO = generateId('customButtonTwo');
export const NODE_ID_HEADER = generateId('header');

export const NODE_DISPLAY_NAME_PAGE_CONTAINER = 'Page';
export const NODE_DISPLAY_NAME_CONTENT_CONTAINER = 'Content';
export const NODE_DISPLAY_NAME_LOGO = 'Logo';
export const NODE_DISPLAY_NAME_EVENT_TITLE = 'Event Title';
export const NODE_DISPLAY_NAME_COUNTDOWN_TEXT = 'Countdown';
export const NODE_DISPLAY_NAME_CHECK_IN_BUTTON = 'Check-In Button';
export const NODE_DISPLAY_NAME_FOOTER_CONTAINER = 'Footer';
export const NODE_DISPLAY_NAME_CONTACT_ORGANIZER_BUTTON = 'Contact Organizer Button';
export const NODE_DISPLAY_NAME_VISIT_EVENT_PAGE_BUTTON = 'Visit Event Page Button';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON = 'Custom Button One';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON_TWO = 'Custom Button Two';
export const NODE_DISPLAY_NAME_HEADER = 'Header';
